import React, { Fragment, useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import Select from "react-select";
import { toast } from "react-toastify";
import {
  Row,
  Col,
  CardHeader,
  CardBody,
  CardFooter,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { Btn, H4, Spinner } from "../../../AbstractElements";
import {
  EditProfile,
  Company,
  Username,
  UsersCountryMenu,
  AboutMe,
  UpdateProfile,
  FirstName,
  LastName,
  Address,
  EmailAddress,
  PostalCode,
  Country,
  City,
} from "../../../Constant";
import Dropzone1 from "../../Bonus UI/Dropzones/Dropzone1";
import SingleSelect from "../../SingleSelect/SingleSelect";
import axios from "axios";

const EditMyProfile = () => {
  const [name, setName] = React.useState("");
  const token = localStorage?.getItem("token");
  const [ids, setIds] = useState();
  const num = localStorage?.getItem("currentUser");
  const nameA = localStorage?.getItem("Name");
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [phone_number, setPhoneNumber] = React.useState("");
  const [same, setSame] = React.useState(false);
  const [person_name, setPersonName] = React.useState("");
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [error, setError] = useState(null);
  const [data, setData] = useState();

  const [position, setPosition] = useState("");
  const [signature, setSignature] = useState("");
  const [nameOfFirm, setNameOfFirm] = useState("");
  const [address, setAddress] = useState("");
  const [stampOfFirm, setStampOfFirm] = useState("");
  const [panNumber, setPanNumber] = useState("");
  const [nameOfOrganization, setNameOfOrganization] = useState("");
  const [contactPerson, setContactPerson] = useState("");
  const [province, setProvince] = useState("");
  const [district, setDistrict] = useState("");
  const [city, setCity] = useState("");
  const [profilePic, setProfilePic] = useState("");
  const [currentUpload, setCurrentUpload] = useState("");
  const [nextPage, setNextPage] = useState(false);
  const [proofPic, setProofPic] = useState("");
  const [stampPic, setStampPic] = useState("");
  const [supportingPic, setSupportingPic] = useState();
  const [supportingPic2, setSupportingPic2] = useState();
  const [regisPic, setRegisPic] = useState("");
  const [profile_status, setProfileStatus] = useState(false);
  const [proofPicS, setProofPicS] = useState("");
  const [stampPicS, setStampPicS] = useState("");
  const [regisPicS, setRegisPicS] = useState("");
  const [profilePicS, setProfilePicS] = useState("");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onEditSubmit = (data, files, allFiles) => {
    allFiles.forEach((f) => f.remove());
    toast.success("Dropzone successfully submitted !");
    alert("Form is Submitted");
  };

  const getUploadParams = ({ meta }) => {
    return { url: "https://httpbin.org/post" };
  };


  const validateImageDimensions = (file, callback) => {
    const reader = new FileReader();
    reader.onload = (event) => {
        const img = new window.Image();;
        img.src = event.target.result;

        img.onload = () => {
            const maxWidth = 134; // Maximum allowed width
            const maxHeight = 170; // Maximum allowed height

            if (img.width > maxWidth || img.height > maxHeight) {
                callback(
                    false,
                    `Image dimensions must be smaller than ${maxWidth}x${maxHeight}px. Uploaded image size: ${img.width}x${img.height}px.`
                );
            } else {
                callback(true);
            }
        };
    };
    reader.readAsDataURL(file);
};


  const handleChangeStatus = ({ meta, file, remove }, status) => {
    if (status === 'done') {
      validateImageDimensions(file, (isValid, errorMessage) => {
          if (!isValid) {
              remove();
              toast.warning(errorMessage); // Show error message
          } else {
            setStampPic(file);
              // Proceed with uploading the file
          }
      });
  }

  };

  const getUploadParams2 = ({ meta }) => {

    return { url: "https://httpbin.org/post" };
  };
  const handleChangeStatus2 = ({ meta, file }, status) => {

    setSupportingPic(file);
  };

  const getUploadParams3 = ({ meta }) => {

    return { url: "https://httpbin.org/post" };
  };
  const handleChangeStatus3 = ({ meta, file }, status) => {

    setSupportingPic2(file);
  };
  /*const handleSubmit = (files, allFiles) => {
    allFiles.forEach(f => f.remove());
    toast.success('Dropzone successfully submitted !');
  };*/

  const handleCheckboxChange = (e) => {
    if(nameA !== 'null') {
      setSame(e.target.checked);
      if(same) {
        setContactPerson('');
        setPhoneNumber('');
      } else {
        setContactPerson(nameA);
        setPhoneNumber(num);
      }
    } else {
      toast.error('There is no name currently.')
    }
  };


  const [provinceOption, setSelectedProvinceOption] =
    useState("Province No. 1");
  const [districtOption, setSelectedDistrictOption] = useState("Biratnagar");
  const [cityOption, setSelectedCityOption] = useState("Bhojpur");
  const [titleOption, setSelectedTitleOption] = useState([{
    value: "Automobile Spare Parts",
    label: "Automobile Spare Parts",
  }]);
  const [nameValid, setNameValid] = useState(true);
  const [mobileValid, setMobileValid] = useState(true);
  const [positionValid, setPositionValid] = useState(true);
  const [nameOfFirmValid, setNameOfFirmValid] = useState(true);
  const [nameOfOrganizationValid, setNameOfOrganizationValid] = useState(true);
  const [contactPersonValid, setContactPersonValid] = useState(true);
  const [provinceValid, setProvinceValid] = useState(true);
  const [districtValid, setDistrictValid] = useState(true);
  const [districts, setDistricts] = useState([
    "Bhojpur",
    "Dhankuta",
    "Ilam",
    "Jhapa",
    "Khotang",
    "Morang",
    "Okhaldhunga",
    "Panchthar",
    "Sankhuwasabha",
    "Solukhumbu",
    "Sunsari",
    "Taplejung",
    "Terhathum",
    "Udayapur",
  ]);
  const [cities, setCities] = useState(["Biratnagar", "Dharan", "Itahari"]);
  const [cityValid, setCityValid] = useState(true);
  const [phoneNumberValid, setPhoneNumberValid] = useState(true);
  const [typeOfOrganizationValid, setTypeOfOrganizationValid] = useState(true);
  const [proofPicValid, setProofPicValid] = useState(true);


  useEffect(() => {
    handle_get_firms();
  }, []);


  const handle_get_firms = async () => {
    try {
      const response2 = await axios.get("https://api-portal.nada.org.np/api/firms?status=3", {
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${token}`,
        },
      });
      if (response2?.data?.success) {
        if(response2?.data?.data?.firms?.length !== 0) {
          const firms = response2?.data?.data?.firms;
        const firmNames = firms.map(firm => firm?.name_of_firm);
        const firmIds = firms.map(firm => firm?.id);
        console.log('firmnames', firmNames);
        setData(firmNames);
        setIds(firmIds);
        setSelectedProvinceOption(response2?.data?.data?.firms?.[0]?.name_of_firm);
        } else {
          toast.error("you dont have any verified firms");
          navigate("/proxies");
        }
      }
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response);
        toast.error(error.response.data.message || "An error occurred");
      } else if (error.request) {
        console.error("Error request:", error.request);
        toast.error("No response received from server");
      } else {
        console.error("Error message:", error.message);
        toast.error(error.message);
      }
    }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    if (
      name !== "" &&
      panNumber !== "" &&
      stampPic !== "" &&
      phone_number?.length === 10
    ) {
      try {
        setLoading(true);
        let stamp;
        let support;
        let support2;
        if(stampPic) {
          stamp = await call_picture_upload(stampPic);
        }

        var idFirm = data?.indexOf(provinceOption);


        const response2 = await axios.post(
          "https://api-portal.nada.org.np/api/proxies",
          {
            number: phone_number,
            name: name,
            position: panNumber,
            picture: stamp,
            firm_id: ids?.[idFirm]
          },
          {
            headers: {
              "Content-Type": "application/json",
              "access-control-allow-origin": "*",
              'Authorization': `Bearer ${token}`,
            },
          }
        );
        if (response2?.data?.success) {
          setLoading(false);
          toast.success("Firm submitted successfully.");
          navigate("/proxies");
          //setData(response2?.data?.data?.firms);
        }
      } catch (error) {
        setLoading(false);
        if (error.response) {
          console.error("Error response:", error?.response);
          toast.error(error?.response?.data?.message || "An error occurred");
        } else if (error?.request) {
          console.error("Error request:", error?.request);
          toast.error("No response received from server");
        } else {
          console.error("Error message:", error?.message);
          toast.error(error?.message);
        }
      }
    } else {
      if (name === "") {
        setNameValid(false);
      } else {
        setNameValid(true);
      }

      if (panNumber === "") {
        setPositionValid(false);
      } else {
        setPositionValid(true);
      }

      if (stampPic === "") {
        setProofPicValid(false);
      } else {
        setProofPicValid(true);
      }

      if (phone_number?.length !== 10) {
        setPhoneNumberValid(false);
      } else {
        setPhoneNumberValid(true);
      }
    }
  };

  const call_picture_upload = async (file) => {
    // 1. Get the Presigned URL
    const getUrl = await axios.get(
      `https://api-portal.nada.org.np/api/upload-url?filename=${file.name}&fileType=${file.type}`,
      {
        headers: {
             // Ensure you are sending auth if your backend requires it
            'Authorization': `Bearer ${token}`
        },
      }
    );

    const { uploadUrl, key } = getUrl.data;

    // 2. Upload to S3 (Crucial Fix Here)
    await axios.put(
      uploadUrl,
      file, // <--- Pass 'file' directly. Do NOT wrap in { body: file }
      {
        headers: {
            "Content-Type": file.type
        }
      }
    );

    return "https://d24xzirvx50zjt.cloudfront.net/" + key;
};

  return (
    <Fragment>
      <Form className="card" onSubmit={(e) => handleAdd(e)}>
        <CardHeader className="pb-0">
          <div className="card-options">
            <a className="card-options-collapse" href="#javascript">
              <i className="fe fe-chevron-up"></i>
            </a>
            <a className="card-options-remove" href="#javascript">
              <i className="fe fe-x"></i>
            </a>
          </div>
          {data &&
          <Col sm="6" md="3">
              <div>
                <Label className="col-form-label">{t("Select Organization")}</Label>
                <SingleSelect
                  options={data}
                  selectedOption={provinceOption}
                  onChange={setSelectedProvinceOption}
                />
              </div>
            </Col>
}
        </CardHeader>
        <CardBody>
          <Row>
            <Col md="5">
              <FormGroup className="mb-3">
                {" "}
                <Label className="form-label">{t("Name")}</Label>
                <input
                  className="form-control"
                  name="name"
                  type="text"
                  placeholder={t("Name")}
                  style={{ borderColor: !nameValid ? "#EB0A1E" : null }}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <span style={{ color: "red" }}>
                {!nameValid && t("Name is required")}{" "}
                </span>
              </FormGroup>
            </Col>
            <Col sm="6" md="4">
              <FormGroup>
                {" "}
                <Label className="form-label">{t("Position")}</Label>
                <input
                  className="form-control"
                  name="phone"
                  type="text"
                  style={{ borderColor: !positionValid ? "#EB0A1E" : null }}
                  placeholder={t("Position")}
                  value={panNumber}
                  onChange={(e) => setPanNumber(e.target.value)}
                  //{...register("pan", { required: true })}
                />
                <span style={{ color: "red" }}>
                {!positionValid && t("Position is required")}{" "}
                </span>
              </FormGroup>
            </Col>
            <Col sm="6" md="3">
              <FormGroup>
                {" "}
                <Label className="form-label">{t("Phone Number")}</Label>
                <input
                  className="form-control"
                  name="phone"
                  type="text"
                  style={{ borderColor: !phoneNumberValid ? "#EB0A1E" : null }}
                  placeholder={t("Phone Number")}
                  value={phone_number}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  //{...register("phone", { required: true })}
                />
                <span style={{ color: "red" }}>
                  {!phoneNumberValid && t("Phone Number is required")}{" "}
                </span>
              </FormGroup>
            </Col>
            <Col sm="6" md="4">
              <div>
                {" "}
                <Label className="form-label">{t("Upload Your Passport Size Photo")}(jpeg/png, 132 * 170)</Label>
                <Dropzone1
                  accept="image/jpeg,image/png"
                  getUploadParams={getUploadParams}
                  handleChangeStatus={handleChangeStatus}
                />
              </div>
              <span style={{ color: "red" }}>
                {!proofPicValid && t("Picture is required")}{" "}
                </span>
            </Col>
          </Row>
        </CardBody>
        <CardFooter className="text-end">
        {
            loading?
              <div className="loader-box">
              <Spinner attrSpinner={{ className: 'loader-2' }} />
            </div> : <Btn attrBtn={{ color: "primary", type: "submit" }}>{t("Add Proxy")}</Btn>
          }
        </CardFooter>
      </Form>
    </Fragment>
  );
};
export default EditMyProfile;
